'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';
import ShipmentManagement from './ShipmentManagement';
import CustomerList from './CustomerList';
import BulkOperations from './BulkOperations';
import AdminMetrics from './AdminMetrics';
import RealtimeAlerts from './RealtimeAlerts';
import TeamPerformance from './TeamPerformance';
import OperationalControls from './OperationalControls';

type TabType = 'overview' | 'shipments' | 'customers' | 'bulk' | 'alerts' | 'team' | 'controls';

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState<TabType>('overview');

  const tabs = [
    { id: 'overview' as TabType, label: 'Overview', icon: 'ChartBarIcon' },
    { id: 'shipments' as TabType, label: 'Shipment Management', icon: 'public/assets/images/ChatGPT_Image_Feb_7_2026_02_48_47_AM-1770428942096.png' },
    { id: 'customers' as TabType, label: 'Customer Overview', icon: 'UsersIcon' },
    { id: 'alerts' as TabType, label: 'Real-Time Alerts', icon: 'BellAlertIcon' },
    { id: 'team' as TabType, label: 'Team Performance', icon: 'UserGroupIcon' },
    { id: 'controls' as TabType, label: 'Operations', icon: 'Cog6ToothIcon' },
    { id: 'bulk' as TabType, label: 'Bulk Operations', icon: 'QueueListIcon' },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      {/* Tab Navigation */}
      <div className="bg-card rounded-xl p-2 shadow-card border border-border mb-8">
        <div className="flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-6 py-3 rounded-lg text-sm font-medium transition-all ${
                activeTab === tab.id
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              }`}
            >
              <Icon name={tab.icon} size={20} />
              <span>{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="animate-fade-in">
        {activeTab === 'overview' && <AdminMetrics />}
        {activeTab === 'shipments' && <ShipmentManagement />}
        {activeTab === 'customers' && <CustomerList />}
        {activeTab === 'alerts' && <RealtimeAlerts />}
        {activeTab === 'team' && <TeamPerformance />}
        {activeTab === 'controls' && <OperationalControls />}
        {activeTab === 'bulk' && <BulkOperations />}
      </div>
    </div>
  );
}